import * as React from 'react';
import {useCallback, useEffect, useState} from 'react';
import {Link, Navigate, useLocation, useNavigate} from 'react-router-dom';
import Strings from "../../assets/strings";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {CircularProgress, IconButton, InputAdornment, Theme} from "@mui/material";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {getLSLang, setLSLang} from "../../helpers";
//import {API_PUBLIC} from "../../services";
import {mostrarPerfil} from "../../redux/reducers/authReducer";
import {Facebook, Lock, Person, Visibility, VisibilityOff} from "@mui/icons-material";

import LayOutLogin from "./LayOutLogin";
import {store} from "../../redux/store";
import Notifications from "react-notification-system-redux";
import {API_PUBLIC} from "../../services";
import makeStyles from '@mui/styles/makeStyles';
import {isMobile} from "../../helpers/browser_detect";
import {getIdToken} from "../../services/auth";
// import {
//     LoginSocialGoogle,
//     LoginSocialFacebook,
//     LoginSocialMicrosoft,
//     LoginSocialApple,
//     IResolveParams,
// } from 'reactjs-social-login'

const useStyles = makeStyles((theme:Theme) => ({
    video:{
        position: "absolute",
        top:0,
        left:0,
        height: "calc(100% - 50px)",
        width: "100%",
        zIndex:100,
    },
    root:{
        // background: "#f0f0f4 url('https://egemem.com/theme/bitter/v1/assets/img/bg.png') no-repeat center center",
        //backgroundSize: "cover",
        background:"#f5f5f5",
        textAlign:"center",
        padding:10,
        paddingBottom: 50,
        paddingTop:"4%",
        height: "100vh",
        minHeight: 500,
        position: "relative",
        boxSizing: "border-box",
        [theme.breakpoints.down('md')]: {
            backgroundColor: "red",
        },
    },
    logo:{
        [theme.breakpoints.down('md')]: {
            display: "none"
        },
        "& h1":{
            fontSize: 28,
            fontWeight: 500,
            lineHeight: 1,
        },
        "& h3":{
            color: "#868e96",
            marginBottom: 17,
            fontSize: "1rem"
        }
    },
    form:{
        mt: 1 ,
        width: "100%",
        "& input":{
            padding: "11px 0px !important"
        }
    },
    moreInfo:{
        position: "absolute",
        width: "100%",
        left: 0,
        bottom: 0,
        [theme.breakpoints.up('sm')]: {
            width: 400,
            left: "50%",
            marginLeft:-200,
            borderRadius:2,
            bottom: 10,
        },
    },
    headline:{
        textAlign:"center",
        fontSize: "1.3rem",
    },
    checkCont:{
        textAlign:"left",
        width: "100%",
    },
    submitBtn:{
        marginTop:11,
        width:"100%"
    },
    contraLink:{
        textAlign:"left",
        color: "#868e96",
        textDecoration: "none",
        display: "block",
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    bmLink:{
        marginTop: theme.spacing(1),
        "& a":{
            color: theme.palette.primary.main,
            textTransform: "uppercase",
            textDecoration: "none"
        }
    },
    lang:{
        marginTop: 10,
        marginBottom: 13,
        "& label":{
            display:"block",
            fontSize: ".8em",
        },
        "& select":{
            padding: "2px 7px",
            fontSize: "1em",
        }
    },
    inBtn:{
        padding: 10,
        color: "white",
        width: 400,
        margin: "0 auto",
        borderRadius: "10px 10px",
        background: "linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        textDecoration:"none",
        [theme.breakpoints.down('md')]: {
            width: "calc(100% - 20px)",
            boxSizing: "border-box",
            margin: 10,
        },
    },
}))
const REDIRECT_URI = window.location.href;

export default function SignInSide() {

    const [provider, setProvider] = useState('')
    const [profile, setProfile] = useState<any>()

    const onLoginStart = useCallback(() => {
        alert('login start')
    }, [])
    const onLogoutSuccess = useCallback(() => {
        setProfile(null)
        setProvider('')
        alert('logout success')
    }, [])


    //*****
    const classes = useStyles();

    const navigateTo =useNavigate();
    const {state:urlState}:{state:any} = useLocation();
    const dispatch = useAppDispatch();
    const auth = useAppSelector(state => state.auth)
    const backurl = (urlState?.backurl) ? urlState.backurl:"/inicio";
    const [showPass, setShowPass] = useState(false);

    const [error, setError] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [state, setState] = useState({
        lang:getLSLang("l"),
        userName:"",
        password:"",
        tipo:undefined,
    });
    useEffect(()=>{
        return ()=> {
            store.dispatch(Notifications.removeAll())
        };
    },[])
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>)=>{
        const {name, value} = e.target;
        setState({...state, [name]: value});
    };

    const submitForm = (e?:any,) =>{
        e?.preventDefault();
        let data = {
            inicioSesion: state.userName,
            clave: state.password,
        }
        //simulate login
        // localStorage.setItem("_token", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjEiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiIxIiwiSXNTdXBlckFkbWluIjoiVHJ1ZSIsIlBlcm1pc3Npb25zIjoiIiwiZXhwIjoxNjc3NTI0MTU1fQ.ujVjvtPifuLRh4_zqx5NPLfKmIS5Yi6hd4DyMb22xIo");
        //
        // dispatch(mostrarPerfil({
        //     name:"Deibis Segura Soto",
        //     role:"Admin",
        //     token:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjEiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiIxIiwiSXNTdXBlckFkbWluIjoiVHJ1ZSIsIlBlcm1pc3Npb25zIjoiIiwiZXhwIjoxNjc3NTI0MTU1fQ.ujVjvtPifuLRh4_zqx5NPLfKmIS5Yi6hd4DyMb22xIo",
        //     userName:"deibi12"
        // }));
        // navigateTo(backurl)
        //end simulate login

        setLoading(true);
        setError("");
        API_PUBLIC.post('Auth/LogIn', data)
            .then(({data}) =>{
                localStorage.setItem("_token", data.token);

                // sen token to webview
                if (isMobile?.AndroidWebView()) {
                    if((window as any)?.Android?.logged){
                        (window as any).Android.logged(data.token);
                    }
                }else if(isMobile?.IosWebView()){
                    //window?.webkit?.messageHandlers?.shareFromBase64?.logged(data.token);
                }

                // to get the color en currency
                dispatch(mostrarPerfil(data));
                navigateTo(backurl)

            })
            .catch(({response}) => {
                if(response?.data?.Title)
                    setError(response?.data?.Title);
                else
                    setError("Error");
            }).finally(()=> setLoading(false));

    };


    if ((auth.isAuthenticated && getIdToken())) {
        return <Navigate replace to={backurl}/>;
    }

    return (
        <LayOutLogin>
            {/*<Typography>{(window as any).token}</Typography>*/}
            {/*<Typography>{localStorage.getItem(ID_TOKEN_KEY)}</Typography>*/}
            <Typography sx={{ mt: 2 }} color={"secondary"}>
                {Strings.iniciarSesion.toUpperCase()}
            </Typography>
            {!!error &&
                <Typography color="error" variant="caption" align={"center"}>
                    {error}
                </Typography>
            }
            <Box component="form"   autoComplete={"off"} onSubmit={submitForm} className={classes.form}>

                    <TextField
                        placeholder={Strings.nombreDeUsuario}
                        required
                        margin="normal"
                        name="userName"
                        value={state.userName}
                        onChange={handleChange}
                        InputProps={{
                            startAdornment: <InputAdornment sx={{ml:1}} position="start">
                                <Person />
                            </InputAdornment>,
                        }}
                        variant={"outlined"}
                        fullWidth
                        className={"noAsterisk"}
                        sx={{ mb: 1.5 }}

                    />
                    <TextField
                        placeholder={Strings.contrasena}
                        required
                        margin="normal"
                        name="password"
                        type={showPass?"text":"password"}
                        {...(showPass?{autoComplete:"off"}:{})}
                        value={state.password}
                        onChange={handleChange}
                        variant={"outlined"}
                        InputProps={{
                            startAdornment:  <InputAdornment sx={{ml:1}} position="start" >
                                <Lock/>
                            </InputAdornment>,
                            endAdornment:  <InputAdornment position="end" style={{position: "absolute",right: 0}}>
                                <IconButton
                                    onClick={()=>setShowPass(!showPass)}
                                    size="large">
                                    {showPass ? <Visibility fontSize={"small"}/> : <VisibilityOff fontSize={"small"} />}
                                </IconButton>
                            </InputAdornment>,
                        }}
                        className={"noAsterisk"}
                        fullWidth
                        sx={{ mt:0,mb: 2 }}
                    />


                        <Button
                            disabled={isLoading}
                            type="submit"
                            fullWidth
                            color={"secondary"}
                            variant="contained"
                            sx={{ color: "#fff", borderRadius:"2px" }}
                        >
                            {isLoading? (
                                <span><CircularProgress size={14} color="inherit" /> &nbsp; {Strings.cargando}</span>
                            ):(
                                <span>{Strings.entrar}</span>
                            )}
                        </Button>
                <Link to="/forgotPassword" className={classes.contraLink}>{Strings.olvideMicon}</Link>

            </Box>

            {/*<LoginSocialFacebook*/}
            {/*    isOnlyGetToken*/}
            {/*    appId={"2276583545899680"}*/}
            {/*    onLoginStart={onLoginStart}*/}
            {/*    onResolve={({ provider, data }: IResolveParams) => {*/}
            {/*        setProvider(provider)*/}
            {/*        setProfile(data)*/}
            {/*    }}*/}
            {/*    onReject={(err) => {*/}
            {/*        console.log(err)*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <Button startIcon={<Facebook/>} size={"small"} sx={{textTransform:"none", color:"#1877F2"}}>Entrar con Facebook</Button>*/}
            {/*</LoginSocialFacebook>*/}


            <Typography className={classes.bmLink}>{Strings.noCuenta} <Link to="/register">{Strings.registrarme}</Link></Typography>

            <div className={classes.lang}>
                <select value={state.lang} onChange={(e)=>{
                    let lang = e.target.value;
                    setLSLang(lang);
                    Strings.setLanguage(lang);
                    setState({...state,lang});
                }}>
                    {Strings.getAvailableLanguages().map(l=>
                        <option key={l} value={l}>{(Strings as any)[l]}</option>
                    )}
                </select>
                {/*<label>{Strings.idioma}</label>*/}

            </div>
        </LayOutLogin>
    );
}
